import { Box, Button, FormControl, Grid, Modal, SelectChangeEvent, TextField, Typography } from '@mui/material'
import { useState } from 'react';
import { Tag } from './AddDeviceModal';
import { UpdateDeviceTagsApi } from '../Api';



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    borderRadius: 1,
    boxShadow: 24,
    p: 4,
};

interface UpdateTagsModalProps {
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
    currentTags: Tag[];
    deviceID: string;
    setSnackbar: (snackbar: { open: boolean; message: string; severity: 'success' | 'error' }) => void;
    device: any;
    setSelectedDevice: (device: any) => void;
}

const UpdateTagsModal = ({ openModal, setOpenModal, currentTags, deviceID, setSnackbar, device, setSelectedDevice }: UpdateTagsModalProps) => {
    const [tags, setTags] = useState<Tag[]>(currentTags || []);
    const handleTagChange = (index: number, field: keyof Tag, value: string) => {
        const newTags = [...tags];
        newTags[index][field] = value;
        setTags(newTags);
    };

    const addTag = () => {
        const newTags = [...tags, { key: '', value: '' }];
        setTags(newTags);
    };

    const removeTag = (index: number) => {
        const newTags = tags.filter((_, i) => i !== index);
        setTags(newTags);
    };

    const submitUpdateTags = async () => {
        try {
            const data = {
                deviceID: deviceID,
                tags: tags,
            };
            const res = await UpdateDeviceTagsApi(data);
            if (res !== "Tags Updated successfully") {
                setSnackbar({ open: true, message: "Error on Update Tags", severity: "error" });
                setOpenModal(false);
                return;
            }
            setSnackbar({ open: true, message: "Tags updated", severity: "success" });
            setSelectedDevice({ ...device, tags: tags });
            setOpenModal(false);
        } catch (error) {
            console.error("Error updating device tags:", error);
        }
    }


    return (
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box component="form" sx={style} noValidate autoComplete="off">
                <FormControl fullWidth>
                    <Typography variant="h6" padding="20px 0px">
                        Tags
                    </Typography>
                    {tags.map((tag, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <TextField
                                label="Key"
                                value={tag.key}
                                onChange={(e) => handleTagChange(index, 'key', e.target.value)}
                                sx={{ flex: 1, marginRight: '10px' }}
                            />
                            <TextField
                                label="Value"
                                value={tag.value}
                                onChange={(e) => handleTagChange(index, 'value', e.target.value)}
                                sx={{ flex: 1, marginRight: '10px' }}
                            />
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => removeTag(index)}
                            >
                                Remove
                            </Button>
                        </Box>
                    ))}
                    <Button
                        variant="contained"
                        onClick={addTag}
                        sx={{ marginBottom: '20px' }}
                    >
                        Add Tag
                    </Button>
                </FormControl>
                <Grid container justifyContent={"end"}>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => setOpenModal(false)}
                        sx={{ marginTop: '20px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="success"
                        variant="contained"
                        onClick={() => {
                            submitUpdateTags();
                        }}
                        sx={{ marginLeft: '20px', marginTop: '20px' }}
                    >
                        Add
                    </Button>
                </Grid>
            </Box>
        </Modal>
    )
}

export default UpdateTagsModal